import { useCallback } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { useTranslation } from '@ibk/shared-translation';
import { DocumentTypeNumber, FavoredContactDetailsType } from '../../enums';
import { usePostCreateFavoredContactMutation } from '../../services/pixFavoredContactApi';
function mapPixTypeToPixTypeEnum(pixType) {
    return pixType;
}
function getDocumentTypeFromTaxIdentifier(taxIdentifier) {
    const cleanTaxId = taxIdentifier.replace(/\D/g, '');
    return cleanTaxId.length === 11 ? DocumentTypeNumber.CPF : DocumentTypeNumber.CNPJ;
}
export function useAddFavoredContact() {
    const { t } = useTranslation();
    const [createFavoredContact, { isLoading, error }] = usePostCreateFavoredContactMutation();
    const addFavoredContact = useCallback(async (data) => {
        if (!data.pixKeyDetails?.name || !data.pixKeyDetails?.taxIdentifier) {
            throw new Error(t('incomplete-contact-data'));
        }
        const pixKeyType = mapPixTypeToPixTypeEnum(data.keyType);
        const accountInfo = getSelectedAccountInfo();
        if (!accountInfo?.accountId) {
            throw new Error(t('account-info-not-available'));
        }
        const payload = {
            accountId: accountInfo.accountId,
            name: data.pixKeyDetails.name,
            details: {
                type: FavoredContactDetailsType.PIX_KEY,
                data: {
                    pixKey: data.keyValue,
                    pixKeyType: pixKeyType,
                },
                description: `Chave PIX - ${data.pixKeyDetails.name}`,
            },
        };
        await createFavoredContact(payload).unwrap();
    }, [createFavoredContact, t]);
    return {
        addFavoredContact,
        loading: isLoading,
        error: error ? t('error-adding-contact-to-favorites') : undefined,
    };
}
